module.exports = "fragment ElementTextFragment on ElementText {\n  paragraphs {\n    ...ParagraphFragment\n  }\n}\n"